import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c95a767"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg-white py-10 px-12",
  id: "contact-us"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "py-6 text-red-600 text-2xl p-5 underline underline-offset-8" }, " Contact Us ", -1))
const _hoisted_3 = { class: "border-b border-black pb-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Phone ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pt-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "hover:text-red-600 hover:border-b hover:border-red-600",
    href: `tel:01 675 949`,
    target: "_blank"
  }, "01 675 1949")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pb-5 pt-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "hover:text-red-600 hover:border-b hover:border-red-600",
    href: `tel:086 0400 320`,
    target: "_blank"
  }, "086 0400 320")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "WhatsApp ", -1))
const _hoisted_8 = { class: "pb-5" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " E-mail", -1))
const _hoisted_11 = { class: "pb-5" }
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Location = _resolveComponent("Location")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'phone'] }),
        _createTextVNode(),
        _hoisted_4
      ]),
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("p", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['fab', 'whatsapp'] }),
        _createTextVNode(),
        _hoisted_7
      ]),
      _createElementVNode("p", _hoisted_8, [
        _createElementVNode("a", {
          class: "hover:text-red-600 hover:border-b hover:border-red-600",
          href: `https://wa.me/353860400320`,
          target: "_blank"
        }, "086 0400 320", 8, _hoisted_9)
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'envelope'] }),
        _hoisted_10
      ]),
      _createElementVNode("p", _hoisted_11, [
        _createElementVNode("a", {
          class: "hover:text-red-600 hover:border-b hover:border-red-600",
          href: `mailto:contact@themotorbikedoctor.com`,
          target: "_blank"
        }, "contact@themotorbikedoctor.com", 8, _hoisted_12)
      ])
    ]),
    _createVNode(_component_Location)
  ]))
}